module.exports = __webpack_public_path__ + "img/1428dd8b82b89606c35863228121efc0.png";